import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cnc-icon-selector',
  templateUrl: './icon-selector.component.html',
  styleUrls: ['./icon-selector.component.scss'],
})
export class IconSelectorComponent implements OnInit {
  constructor(
    private http :HttpClient,
    public activeModal :NgbActiveModal,
    private cd :ChangeDetectorRef,
  ) {}

  iconList :any[] = [];
  iconFilter :any;

  ngOnInit() {
    this.http.get('assets/material-icons-list.json').subscribe((iconList :any) => {
      if (iconList && iconList.categories) {
        this.iconList = iconList.categories;
        this.cd.detectChanges();
      }
    });
  }

  useIcon(icon) {
    this.activeModal.close(icon);
  }
}
